import {takeEvery} from 'redux-saga/effects'

import {
  SP_LEARN_LECTURES,
  SP_LEARN_LECTURE_ADD_COMMENT,
  SP_LEARN_LECTURE_COMMENTS,
  SP_LEARN_LECTURE_DETAIL,
  SP_LEARN_LECTURE_ONLINE_USERS,
  SP_LEARN_LIVE_NOW_LECTURES,
  SP_LEARN_QUIZ_ANSWER,
  SP_LEARN_QUIZ_RESULT,
  SP_LEARN_QUIZ_START,
  SP_LEARN_QUIZ_STATE,
  SP_LEARN_QUIZ_SUBMIT,
  SP_LEARN_QUIZ_TIME_LEFT,
  SP_LEARN_SIDEBAR_LECTURES,
  SP_LEARN_SUBJECTS,
} from '../../Actions/SpLearn/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

/** Student/parent online quizzes and video lectures (native quiz and lecture pages). */
function* dataSaga() {
  yield takeEvery(SP_LEARN_QUIZ_STATE, fetchData)
  yield takeEvery(SP_LEARN_QUIZ_START, fetchData)
  yield takeEvery(SP_LEARN_QUIZ_ANSWER, fetchData)
  yield takeEvery(SP_LEARN_QUIZ_SUBMIT, fetchData)
  yield takeEvery(SP_LEARN_QUIZ_TIME_LEFT, fetchData)
  yield takeEvery(SP_LEARN_QUIZ_RESULT, fetchData)
  yield takeEvery(SP_LEARN_LECTURES, fetchData)
  yield takeEvery(SP_LEARN_LIVE_NOW_LECTURES, fetchData)
  yield takeEvery(SP_LEARN_SIDEBAR_LECTURES, fetchData)
  yield takeEvery(SP_LEARN_LECTURE_DETAIL, fetchData)
  yield takeEvery(SP_LEARN_LECTURE_COMMENTS, fetchData)
  yield takeEvery(SP_LEARN_LECTURE_ADD_COMMENT, fetchData)
  yield takeEvery(SP_LEARN_LECTURE_ONLINE_USERS, fetchData)
  yield takeEvery(SP_LEARN_SUBJECTS, fetchData)
}

export default dataSaga
